"use client";
import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { stateLayers } from "../../../styles/states.css.js";
import classNames from "classnames";
import { forwardRef, createElement } from "react";
import "../../../foundation/iconography/ExtraIconsProvider.js";
import "../../../foundation/iconography/IconVariantProvider.js";
import "../../../foundation/iconography/icons.js";
import { Icon } from "../../../foundation/iconography/Icon.js";
import { BodyText } from "../../../foundation/typography/index.js";
import { buttonRecipe, iconButton, actionText } from "./styles.css.js";
const IconButton = forwardRef(
  // @ts-expect-error - This is a valid type
  function IconButton2({ $as, as, className, showLabel, label, icon, variantOverride, ...props }, ref) {
    return createElement($as ?? as ?? "button", {
      ...props,
      ref,
      className: classNames(className, buttonRecipe({ color: "transparent", buttonType: "icon" }), iconButton({ showLabel }), stateLayers({
        borderSize: "medium",
        borderRadius: "button",
        backgroundColor: "palette-black",
        setFocusState: true
      }))
    }, jsxs(Fragment, { children: [showLabel === "left" && jsx(BodyText, { className: actionText, children: label }), jsx(Icon, { icon, title: showLabel ? void 0 : label, variantOverride }), showLabel === "right" && jsx(BodyText, { className: actionText, children: label })] }));
  }
);
export {
  IconButton
};
